import React from 'react'
import className from 'classnames'
import trending_up from '../../../assets/icons/trending_up.svg'
import FeatureImage from '../../../shared/FeatureImage'
import PropTypes from 'prop-types'
import {ReactComponent as IconCheck} from '../../../assets/icons/check.svg'
import WithStoreSettings from '../../../shared/WithStoreSettings'
import {getAccessToken} from "../../../services/AuthServices";
import {getCurrentStore} from "../../../services/CurrentStoreServices";
import { useNavigate } from 'react-router-dom'

const ProductLinesContainer = (props) => {
    const {product, selectedProduct, onHandleSelectProduct, store} = props
    const navigate = useNavigate()

    const {
        sku = '',
        title = '',
        is_popular = false,
        disabled = false,
        thumbnail_link,
        _id,
        tag = '',
        mockup_type,
    } = product

    const isSelected = selectedProduct === _id

    const _navigateDesign = (productId) => {
        const accessToken = getAccessToken()
        const currentStore = getCurrentStore()
        if (!accessToken || !currentStore) {
            return navigate(`/${selectedProduct}`)
        }
        navigate(`/${selectedProduct}?storeId=${currentStore}&path=backoffice&accessToken=${accessToken}`)
    }

    return (
        <div className={className('ProductGenerator', {Disabled: disabled}, {SelectedProduct: isSelected})}>
            {is_popular && (
                <label className="LabelPopular d-flex">
                    Popular
                    <div className="IconHolder ml-1">
                        <img src={trending_up} alt="vector" className="vector" />
                    </div>
                </label>
            )}

            <div onDoubleClick={() => _navigateDesign(_id)} onClick={() => onHandleSelectProduct(_id)}>
                <FeatureImage bgSize="cover" src={thumbnail_link} className="w-100" />
            </div>

            <div className="content p-2">
                {sku && <label className="LabelKey">{sku}</label>}
                {title && (
                    <div className="d-flex justify-content-between mb-1">
                        <span className="ProductGeneratorNameDoubleLine">{title}</span>
                    </div>
                )}
                {/* {store.hasFeature("exclude_combine_create_product_flow") && store.hasStoreRole('admin') && tag && (
                    <div className="LabelTag" style={{backgroundColor: TAG_COLORS[tag]}}>
                        <img src={IconInfo} alt="" />
                        <span className="ml-1">{tag}</span>
                    </div>
                )} */}
            </div>

            {isSelected && (
                <div className="Mask" onClick={() => onHandleSelectProduct(_id)}>
                    <span className="Icon">
                        <IconCheck width={18} height={14} />
                    </span>
                </div>
            )}
        </div>
    )
}

ProductLinesContainer.propTypes = {
    product: PropTypes.object.isRequired,
    selectedProduct: PropTypes.string.isRequired,
    onHandleSelectProduct: PropTypes.func.isRequired,
}
// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    return (
        <WithStoreSettings>
            {(store) => {
                return <ProductLinesContainer {...props} store={store} />
            }}
        </WithStoreSettings>
    )
}

